(function () {
    'use strict';

    angular.module('modules.page-performance.pages', [
        'modules.page-performance.pages.domain',
        'modules.page-performance.pages.admin',
    ]);
})();
